import { render } from "./LoadingAnimation.vue?vue&type=template&id=38126ab0&scoped=true"
const script = {}

import "./LoadingAnimation.vue?vue&type=style&index=0&id=38126ab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38126ab0"]])

export default __exports__